import React from 'react';

const HLSPlayer = ({ video, onClose }) => {
  // Encode the video URL for use in the iframe
  const encodedVideoUrl = encodeURIComponent(video.videoUrl);

  // You can use different HLS player services
  // Option 1: Using livereacting.com player (as in your example)
  const playerUrl = `https://www.livereacting.com/tools/hls-player-embed?url=${encodedVideoUrl}`;

  // Option 2: Using your own HLS player service (if you have one)
  // const playerUrl = `https://your-hls-player-service.com/embed?url=${encodedVideoUrl}`;

  // Option 3: Using a different HLS player service
  // const playerUrl = `https://player.vimeo.com/video/${videoId}?h=${hash}`;

  return (
    <div className="bg-white bg-opacity-25 p-2 rounded-lg overflow-hidden shadow-lg">
      <div className="relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 rounded-full p-2 hover:bg-opacity-70 transition-all"
        >
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Responsive HLS Player - 100% width, 16:9 aspect ratio */}
        <div style={{ position: 'relative', width: '100%', margin: '0 auto' }}>
          <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden' }}>
            <iframe
              src={playerUrl}
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              frameBorder="0"
              allowFullScreen
              title="HLS Video Player"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HLSPlayer;